<template lang="pug">
vs-row(
  v-if="dataInfo"
  vs-w="8"
)
  vs-col(
    vs-type="flex"
    vs-justify="flex-start"
    vs-align="center"
    vs-lg="12"
    vs-sm="12"
    vs-xs="12"
    style="padding: 0px; width: 40px !important"
    v-if="dataInfo.company.config_theme && (dataInfo.company.config_theme.dark.logo || dataInfo.company.config_theme.light.logo)"
  )
    img(
      :src="($store.state.theme === 'dark' ? dataInfo.company.config_theme.dark.logo : dataInfo.company.config_theme.light.logo)"
      style="width: 100%; height: 100%;"
    )

  vs-col(
    vs-type="flex"
    vs-justify="flex-start"
    vs-align="center"
    vs-lg="12"
    vs-sm="12"
    vs-xs="12"
    style="padding: 0px;"
    v-else
  )
    <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M38.1078 43.8294C27.9115 46.3235 17.7152 46.3235 7.59221 43.8294C5.17151 43.1693 2.45738 40.5285 1.87055 38.1078C-0.623515 27.9115 -0.623515 17.7152 1.87055 7.59221C2.53074 5.17151 5.17151 2.45738 7.59221 1.87055C17.7885 -0.623515 27.9848 -0.623515 38.1078 1.87055C40.5285 2.53074 43.2426 5.17151 43.8294 7.59221C46.3235 17.7885 46.3235 27.9848 43.8294 38.1078C43.2426 40.5285 40.6018 43.2426 38.1078 43.8294Z" fill="#FDD402"/>
      <path d="M20.5758 36.8606C28.7999 36.8606 35.4668 30.1937 35.4668 21.9696C35.4668 13.7455 28.7999 7.07861 20.5758 7.07861C12.3517 7.07861 5.68481 13.7455 5.68481 21.9696C5.68481 30.1937 12.3517 36.8606 20.5758 36.8606Z" fill="black"/>
      <path d="M38.9144 38.1077C38.7677 38.1077 38.6944 38.0343 38.5477 37.961L30.3319 32.5327C29.6717 33.0462 28.9382 33.633 28.278 34.0732C28.1313 34.1465 28.1313 34.1465 27.9846 34.1465C27.8379 34.1465 27.6178 34.0732 27.5445 33.9265L24.4636 29.8919L13.9738 16.468C13.8271 16.248 13.8271 15.9546 14.0472 15.8078C14.1939 15.6611 14.2672 15.6611 14.4873 15.6611C14.634 15.6611 14.7807 15.7345 14.8541 15.8078L27.5445 26.591C27.9846 26.0041 28.3514 25.2706 28.5714 24.6104C28.6448 24.4637 28.7915 24.2436 29.0115 24.1703C29.0849 24.1703 29.0849 24.1703 29.1583 24.1703C29.305 24.1703 29.525 24.2436 29.5984 24.3903L32.8993 28.7183L39.4279 37.1541C39.5746 37.3741 39.5746 37.6675 39.3546 37.8143C39.1345 37.961 39.0611 38.1077 38.9144 38.1077Z" fill="#FBBE02"/>
      <path d="M14.4141 16.1013L27.6179 27.2512C28.2781 26.5177 28.7916 25.5641 29.085 24.6104L32.386 28.9384L38.9146 37.5209L30.4054 31.8726C29.7452 32.5328 28.9383 33.1196 28.1314 33.5597L24.9772 29.4519L14.4141 16.1013ZM14.4141 15.001C14.1207 15.001 13.9006 15.1477 13.6805 15.3678C13.2404 15.8079 13.2404 16.3947 13.5338 16.8348L23.9502 30.3321L27.0311 34.3666C27.2512 34.66 27.5446 34.8068 27.9114 34.8068C28.1314 34.8068 28.3515 34.7334 28.4249 34.66C29.085 34.2199 29.6719 33.8531 30.2587 33.3397L38.181 38.4745C38.3277 38.6212 38.6212 38.6212 38.7679 38.6212C39.0613 38.6212 39.3547 38.4745 39.5748 38.2544C40.0149 37.8143 40.0149 37.3008 39.6481 36.7873L33.0462 28.2782L29.7452 23.9503C29.5252 23.6568 29.2318 23.5101 28.865 23.5101C28.7916 23.5101 28.7183 23.5101 28.7183 23.5101C28.2781 23.5835 28.0581 23.8769 27.838 24.1703C27.6913 24.6838 27.3979 25.1239 27.1778 25.6374L15.0743 15.3678C14.9276 15.1477 14.7075 15.001 14.4141 15.001Z" fill="black"/>
      <path d="M23.7301 30.0385C22.9232 30.4053 22.1163 30.552 21.2361 30.552C16.468 30.9922 12.4335 27.3978 11.9934 22.7031C11.8467 20.7225 12.4335 18.6686 13.5338 17.0548C13.9006 16.5413 14.194 16.1745 14.7075 15.661C16.1012 14.2673 17.8617 13.4604 19.769 13.3137C24.6104 12.8735 28.7916 16.4679 29.2317 21.236C29.3051 21.7495 29.3051 22.1162 29.3051 22.7031L33.1195 27.6178C36.2004 20.6491 33.1195 12.5068 26.1508 9.35252C19.1821 6.27162 11.1131 9.35252 8.10556 16.3212C8.10556 16.3946 8.0322 16.4679 8.0322 16.4679C4.95131 23.51 8.0322 31.6524 15.0009 34.8066C17.1282 35.6869 19.4022 36.127 21.7495 35.9803C23.5834 35.8336 25.3439 35.2467 26.9577 34.3665L23.7301 30.0385Z" fill="white"/>
    </svg>
  list-services(
    ref='ListGeneral'
    :dataInfoArray="dataInfo"
    :statusArray="status"
    :minuteRouter="minuteRouter"
    :isSidebarActive="popupActivoServices"
    :show_delivery_time="show_delivery_time"
    @searchServi="searchServices"
    @closeSidebar="setWindowsClose(false)"
    @closeSidebar2="setWindowsClose(true)"
  )
</template>

<script>
// import Config from "@/api/config/config"
import MapForm from "@/components/towerControl/Form"
import ListServices from "@/components/towerControl/ListServicesGeneral"
import { isMobile } from 'mobile-device-detect'
// import SlideOut component, and set the defaults props
import HTTP from "@/http-common";
import L from 'leaflet';
import { mapState } from "vuex"
import { encryptSearchCode, decryptSearchCode } from "@/utils/encryption.js"

const NAME = "ServicesActions"

export default {
  name: NAME,
  components: {
    "vue-form": MapForm,
    "list-services": ListServices
  },
  data() {
    return {
      popupActivo: true,
      popupActivo2: false,
      popupActivoServices: false,
      status: [],
      v1: 'hidden',
      gravity: 'left',
      anchorPosition: 0.5,
      anchorEnabled: false,
      touchEnabled: false,
      offset: '40%',
      collapsedOffset: '56px',
      scrim: false,
      markers: [],
      lenght: [],
      dataInfo: null,
      minuteRouter: 0,
      dataCompany: null,
      placa_tracing: null,
      infoDataAct: null,
      funcionInterval: null,
      polylineArray: [],
      show_driver: false,
      show_icon: false,
      show_trajectory_line: false,
      show_delivery_time: false,
      company_status: [],
      code: '',
      extractedToken: null
    }

  },
  computed: {
    ...mapState(["img"]),
  },
  watch: {
    $route() {
      this.getQuerySearchCode()
    }
  },
  sockets: {
    'connect'() {
      console.log('socket connected')
    },
    async update_gps(data) {
      let dataCar = null
      if (typeof (data) == 'object') {
        dataCar = data
      } else {
        dataCar = JSON.parse(data)
      }
      if (this.placa_tracing == dataCar.placa) {
        let infoCar = {
          lng: dataCar.cx,
          lat: dataCar.cy,
          placa: dataCar.placa
        }
        this.$store.dispatch("map/tracingPoint", infoCar)
        this.$store.dispatch("map/visibleTracing", true)
        const resultTime = await this.calculateTime(this.dataInfo.cx_cliente, this.dataInfo.cy_cliente, infoCar.lng, infoCar.lat, this.dataInfo.company[0].toLowerCase(), this.dataInfo.placa)
        this.minuteRouter = resultTime.data.total_travel_time
      }
    }
  },
  mounted() {
    this.loginRoute()
    console.log("=== DEBUG: Componente montado, llamando getQuerySearchCode ===");
    this.getQuerySearchCode()
  },
  methods: {
    setVisibleMobile() {
      return isMobile ? true : false
    },
    async getQuerySearchCode() {
      console.log("=== DEBUG: getQuerySearchCode iniciado ===");
      console.log("Route params:", this.$route.params);
      console.log("Route query:", this.$route.query);
      
      if (this.$route.params.encoded) {
        console.log("DEBUG: Encontrado parámetro encoded:", this.$route.params.encoded);
        const encryptedCode = this.$route.params.encoded;
        const decryptedCode = decryptSearchCode(encryptedCode);
        
        if (decryptedCode) {
          this.code = decryptedCode;
          
          console.log("URL encriptada detectada:", encryptedCode);
          console.log("Código desencriptado:", this.code);
          console.log("DEBUG: Llamando searchServices con código:", this.code);
          
          if (this.dataInfo) {
            this.$refs.ListGeneral.DeactivateButton(true)
          }
          this.searchServices(this.code)
          return;
        } else {
          console.error("Error al desencriptar el código de la URL:", encryptedCode);
        }
      }

      if (this.$route.query.hasOwnProperty('guia')) {
        // Parámetro guia no permitido - siempre redirige a Login
        console.log("🚨 GUIA parameter not allowed - redirecting to Login");
        console.log("DEBUG: Current path:", this.$route.path);
        this.$router.push({ name: 'Login' })
        return;
      } else if (this.$route.query.hasOwnProperty('track')) {
        // Soporte para parámetro track - solo funciona en ruta /seguimiento/dorado
        if (this.$route.path !== '/seguimiento/dorado') {
          console.log("🚨 TRACK parameter only allowed on /seguimiento/dorado path");
          console.log("DEBUG: Current path:", this.$route.path);
          this.$router.push({ name: 'Login' })
          return;
        }
        
        const trackValue = this.$route.query.track;
        const tokenValue = this.$route.query.token;
        
        console.log('🚛 TRACK parameter detected on /seguimiento/dorado:', trackValue);
        console.log('🚛 Token from query:', tokenValue);
        
        // Validar que ambos parámetros estén presentes
        if (!trackValue || !tokenValue) {
          console.log("🚨 TRACK requires both track and token parameters");
          this.$router.push({ name: 'Login' })
          return;
        }
        
        // Crear código completo track-token
        const fullCode = `${trackValue}|${tokenValue}`;
        
        console.log(' Full code (track-token):', fullCode);
        console.log("DEBUG: Llamando searchServices con código completo:", fullCode);
        
        if (this.dataInfo) {
          this.$refs.ListGeneral.DeactivateButton(true)
        }
        this.searchServices(fullCode); // Usar código completo con token
        return;
      } else if (this.$route.query.hasOwnProperty('q')) {
        console.log("DEBUG: Encontrado query q (producción):", this.$route.query.q);
        console.log("DEBUG: Token en query:", this.$route.query.token);
        
        const encryptedCodeFromQuery = this.$route.query.q;
        const decryptedCode = decryptSearchCode(encryptedCodeFromQuery);
        
        if (decryptedCode) {
          this.code = decryptedCode;
          console.log("Código desencriptado desde query q:", this.code);
          
          if (this.dataInfo) {
            this.$refs.ListGeneral.DeactivateButton(true)
          }
          console.log("DEBUG: Llamando searchServices con código desde query q:", this.code);
          this.searchServices(this.code) // Backend producción
        } else {
          console.error("Error al desencriptar el código desde query q:", encryptedCodeFromQuery);
          this.$router.push({ name: 'Login' })
        }
      } else {
        console.log("DEBUG: No hay parámetros, redirigiendo a Login");
        this.$router.push({ name: 'Login' })
      }
    },
    activateSocket() {
      this.$socket.io.opts.query = {
        token: localStorage.getItem('TokenSocket')
      }
      this.$socket.open()
    },
    activateSocketPlaca(val) {
      let placa = `PLACA:${val}`
      this.$socket.emit('joinRoom', placa)
    },
    activeSocketService(val) {
      let service = val
      this.$socket.emit('joinRoom', service)
      this.sockets.subscribe('service_update', (payload) => {
        this.setInfoACT(payload, true)
      });
    },
    DeactiveSocket() {
      this.sockets.unsubscribe('service_update')
    },
    setPopup() {
      if (this.status.length > 0 || this.dataInfo != null) {
        this.popupActivoServices = true
      } else {
        this.popupActivo = !this.popupActivo
      }
    },
    setWindowsClose(data) {
      this.popupActivoServices = data
    },
    getFirstPoint(infoCarFirst) {
      this.$store.dispatch("map/tracingPoint", infoCarFirst)
      this.$store.dispatch("map/visibleTracing", true)
    },
    async md5(message) {
      // Small MD5 implementation as SubtleCrypto doesn't support MD5
      const rotateLeft = (lValue, iShiftBits) => (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
      const addUnsigned = (lX, lY) => {
        const lX8 = (lX & 0x80000000);
        const lY8 = (lY & 0x80000000);
        const lX4 = (lX & 0x40000000);
        const lY4 = (lY & 0x40000000);
        const lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF);
        if (lX4 & lY4) return (lResult ^ 0x80000000 ^ lX8 ^ lY8);
        if (lX4 | lY4) {
          if (lResult & 0x40000000) return (lResult ^ 0xC0000000 ^ lX8 ^ lY8);
          else return (lResult ^ 0x40000000 ^ lX8 ^ lY8);
        } else return (lResult ^ lX8 ^ lY8);
      };
      const F = (x, y, z) => (x & y) | ((~x) & z);
      const G = (x, y, z) => (x & z) | (y & (~z));
      const H = (x, y, z) => (x ^ y ^ z);
      const I = (x, y, z) => (y ^ (x | (~z)));
      const FF = (a, b, c, d, x, s, ac) => {
        a = addUnsigned(a, addUnsigned(addUnsigned(F(b, c, d), x), ac));
        return addUnsigned(rotateLeft(a, s), b);
      };
      const GG = (a, b, c, d, x, s, ac) => {
        a = addUnsigned(a, addUnsigned(addUnsigned(G(b, c, d), x), ac));
        return addUnsigned(rotateLeft(a, s), b);
      };
      const HH = (a, b, c, d, x, s, ac) => {
        a = addUnsigned(a, addUnsigned(addUnsigned(H(b, c, d), x), ac));
        return addUnsigned(rotateLeft(a, s), b);
      };
      const II = (a, b, c, d, x, s, ac) => {
        a = addUnsigned(a, addUnsigned(addUnsigned(I(b, c, d), x), ac));
        return addUnsigned(rotateLeft(a, s), b);
      };
      const convertToWordArray = (string) => {
        let lWordCount;
        const lMessageLength = string.length;
        const lNumberOfWords_temp1 = lMessageLength + 8;
        const lNumberOfWords_temp2 = (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64;
        const lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;
        const lWordArray = new Array(lNumberOfWords);
        let lBytePosition = 0;
        let lByteCount = 0;
        while (lByteCount < lMessageLength) {
          lWordCount = (lByteCount - (lByteCount % 4)) / 4;
          lBytePosition = (lByteCount % 4) * 8;
          lWordArray[lWordCount] = (lWordArray[lWordCount] | (string.charCodeAt(lByteCount) << lBytePosition));
          lByteCount++;
        }
        lWordCount = (lByteCount - (lByteCount % 4)) / 4;
        lBytePosition = (lByteCount % 4) * 8;
        lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);
        lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
        lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
        return lWordArray;
      };
      const wordToHex = (lValue) => {
        let WordToHexValue = "", WordToHexValue_temp = "", lByte, lCount;
        for (lCount = 0; lCount <= 3; lCount++) {
          lByte = (lValue >>> (lCount * 8)) & 255;
          WordToHexValue_temp = "0" + lByte.toString(16);
          WordToHexValue = WordToHexValue + WordToHexValue_temp.substr(WordToHexValue_temp.length - 2, 2);
        }
        return WordToHexValue;
      };
      const x = convertToWordArray(message);
      let a = 0x67452301, b = 0xEFCDAB89, c = 0x98BADCFE, d = 0x10325476;
      for (let k = 0; k < x.length; k += 16) {
        let AA = a, BB = b, CC = c, DD = d;
        a = FF(a, b, c, d, x[k + 0], 7, 0xD76AA478); d = FF(d, a, b, c, x[k + 1], 12, 0xE8C7B756); c = FF(c, d, a, b, x[k + 2], 17, 0x242070DB); b = FF(b, c, d, a, x[k + 3], 22, 0xC1BDCEEE);
        a = FF(a, b, c, d, x[k + 4], 7, 0xF57C0FAF); d = FF(d, a, b, c, x[k + 5], 12, 0x4787C62A); c = FF(c, d, a, b, x[k + 6], 17, 0xA8304613); b = FF(b, c, d, a, x[k + 7], 22, 0xFD469501);
        a = FF(a, b, c, d, x[k + 8], 7, 0x698098D8); d = FF(d, a, b, c, x[k + 9], 12, 0x8B44F7AF); c = FF(c, d, a, b, x[k + 10], 17, 0xFFFF5BB1); b = FF(b, c, d, a, x[k + 11], 22, 0x895CD7BE);
        a = FF(a, b, c, d, x[k + 12], 7, 0x6B901122); d = FF(d, a, b, c, x[k + 13], 12, 0xFD987193); c = FF(c, d, a, b, x[k + 14], 17, 0xA679438E); b = FF(b, c, d, a, x[k + 15], 22, 0x49B40821);
        a = GG(a, b, c, d, x[k + 1], 5, 0xF61E2562); d = GG(d, a, b, c, x[k + 6], 9, 0xC040B340); c = GG(c, d, a, b, x[k + 11], 14, 0x265E5A51); b = GG(b, c, d, a, x[k + 0], 20, 0xE9B6C7AA);
        a = GG(a, b, c, d, x[k + 5], 5, 0xD62F105D); d = GG(d, a, b, c, x[k + 10], 9, 0x02441453); c = GG(c, d, a, b, x[k + 15], 14, 0xD8A1E681); b = GG(b, c, d, a, x[k + 4], 20, 0xE7D3FBC8);
        a = GG(a, b, c, d, x[k + 9], 5, 0x21E1CDE6); d = GG(d, a, b, c, x[k + 14], 9, 0xC33707D6); c = GG(c, d, a, b, x[k + 3], 14, 0xF4D50D87); b = GG(b, c, d, a, x[k + 8], 20, 0x455A14ED);
        a = GG(a, b, c, d, x[k + 13], 5, 0xA9E3E905); d = GG(d, a, b, c, x[k + 2], 9, 0xFCEFA3F8); c = GG(c, d, a, b, x[k + 7], 14, 0x676F02D9); b = GG(b, c, d, a, x[k + 12], 20, 0x8D2A4C8A);
        a = HH(a, b, c, d, x[k + 5], 4, 0xFFFA3942); d = HH(d, a, b, c, x[k + 8], 11, 0x8771F681); c = HH(c, d, a, b, x[k + 11], 16, 0x6D9D6122); b = HH(b, c, d, a, x[k + 14], 23, 0xFDE5380C);
        a = HH(a, b, c, d, x[k + 1], 4, 0xA4BEEA44); d = HH(d, a, b, c, x[k + 4], 11, 0x4BDECFA9); c = HH(c, d, a, b, x[k + 7], 16, 0xF6BB4B60); b = HH(b, c, d, a, x[k + 10], 23, 0xBEBFBC70);
        a = HH(a, b, c, d, x[k + 13], 4, 0x289B7EC6); d = HH(d, a, b, c, x[k + 0], 11, 0xEAA127FA); c = HH(c, d, a, b, x[k + 3], 16, 0xD4EF3085); b = HH(b, c, d, a, x[k + 6], 23, 0x04881D05);
        a = HH(a, b, c, d, x[k + 9], 4, 0xD9D4D039); d = HH(d, a, b, c, x[k + 12], 11, 0xE6DB99E5); c = HH(c, d, a, b, x[k + 15], 16, 0x1FA27CF8); b = HH(b, c, d, a, x[k + 2], 23, 0xC4AC5665);
        a = II(a, b, c, d, x[k + 0], 6, 0xF4292244); d = II(d, a, b, c, x[k + 7], 10, 0x432AFF97); c = II(c, d, a, b, x[k + 14], 15, 0xAB9423A7); b = II(b, c, d, a, x[k + 5], 21, 0xFC93A039);
        a = II(a, b, c, d, x[k + 12], 6, 0x655B59C3); d = II(d, a, b, c, x[k + 3], 10, 0x8F0CCC92); c = II(c, d, a, b, x[k + 10], 15, 0xFFEFF47D); b = II(b, c, d, a, x[k + 1], 21, 0x85845DD1);
        a = II(a, b, c, d, x[k + 8], 6, 0x6FA87E4F); d = II(d, a, b, c, x[k + 15], 10, 0xFE2CE6E0); c = II(c, d, a, b, x[k + 6], 15, 0xA3014314); b = II(b, c, d, a, x[k + 13], 21, 0x4E0811A1);
        a = II(a, b, c, d, x[k + 4], 6, 0xF7537E82); d = II(d, a, b, c, x[k + 11], 10, 0xBD3AF235); c = II(c, d, a, b, x[k + 2], 15, 0x2AD7D2BB); b = II(b, c, d, a, x[k + 9], 21, 0xEB86D391);
        a = addUnsigned(a, AA); b = addUnsigned(b, BB); c = addUnsigned(c, CC); d = addUnsigned(d, DD);
      }
      return wordToHex(a) + wordToHex(b) + wordToHex(c) + wordToHex(d);
    },
    async generarToken(guia) {
      console.log("Generando token en ServicesActions para:", guia);
      const PREFIX = "65-A";
      const SALT = "gearnw87xyn348r72487248x7245mx74mx3h34";
      if (!guia) throw new Error("Guía requerida");
      const guiaStr = String(guia).trim();
      const base = PREFIX + guiaStr;
      const raw = base + SALT;
      const hash = await this.md5(raw);
      const tokenResult = `E${hash}${SALT}`;
      console.log("Token calculado:", tokenResult);
      return tokenResult;
    },
    async searchServices(code) {
      try {
        console.log('📡 DEBUG BACKEND REQUEST:');
        console.log('📡 Code original a buscar:', code);
        
        // Solo cambiar URL si es necesario para consistencia visual
        if (this.$route.query.guia || code != this.code) {
          const encryptedCode = encryptSearchCode(code);
          this.$router.replace({ path: `/seguimiento/${encryptedCode}` });
        }
        
        // Paso 1: Obtener Bearer token para autenticación
        console.log('🔑 Obteniendo Bearer token...');
        const authUrl = `${window.location.origin}/tracking-api/api/login/`;
        const authData = {
          user: "admin",
          password: "admin123"
        };
        
        const authResponse = await fetch(authUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(authData)
        });
        
        console.log('🔑 AUTH Status:', authResponse.status);
        const authResult = await authResponse.text();
        console.log('🔑 AUTH Response (raw):', authResult);
        
        let bearerToken;
        try {
          const authJson = JSON.parse(authResult);
          console.log('🔑 AUTH Response (parsed):', authJson);
          bearerToken = authJson.token || authJson.data?.token || authJson.access_token || authJson.accessToken || authJson.jwt;
          console.log('🔑 Extracted token:', bearerToken);
        } catch (e) {
          console.log('🔑 AUTH Response is not JSON, using as raw token. Error:', e);
          bearerToken = authResult.trim();
          console.log('🔑 Raw token:', bearerToken);
        }
        
        if (!authResponse.ok) {
          console.log('🚨 AUTH FAILED - Bad response status:', authResponse.status);
          throw new Error(`Authentication failed: ${authResponse.status}`);
        }
        
        if (!bearerToken) {
          console.log('🚨 AUTH FAILED - No token extracted');
          throw new Error(`No token found in auth response`);
        }
        
        console.log('✅ Authentication successful, proceeding to search...');
        
        // Paso 2: Hacer búsqueda con formato de producción
        const encryptedCode = encryptSearchCode(code);
        
        console.log('🔥 PRODUCTION BACKEND (via nginx proxy):');
        console.log('🔥 Code original:', code);
        console.log('🔥 Code encriptado:', encryptedCode);
        
        // Usar formato de producción: parámetro q + Bearer token
        const searchUrl = `${window.location.origin}/tracking-api/v1/services/search/?q=${encodeURIComponent(encryptedCode)}`;
        
        console.log('🔥 SEARCH URL:', searchUrl);
        console.log('🔥 Parameters:');
        console.log('   - q (query):', encryptedCode);
        console.log('   - Authorization: Bearer', bearerToken.substring(0, 20) + '...');
        
        const searchResponse = await fetch(searchUrl, {
          method: 'GET',
          headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${bearerToken}`
          }
        });
        
        console.log('🔥 SEARCH Status:', searchResponse.status);
        const searchResult = await searchResponse.text();
        console.log('🔥 SEARCH Response Body:', searchResult);
        
        let parsedResult;
        try {
          parsedResult = JSON.parse(searchResult);
        } catch (e) {
          console.log('⚠️ Response no es JSON válido:', e);
          parsedResult = { error: 'Invalid JSON response', raw: searchResult };
        }
        
        const response = { 
          status: searchResponse.status, 
          data: parsedResult 
        };
        
        console.log('🔥 FINAL RESPONSE:', response);
        
        this.infoDataAct = response.data;
        if (this.infoDataAct && this.infoDataAct.data) {
          this.clearMap()
          if (this.dataInfo) {
            this.$refs.ListGeneral.DeactivateButton(false)
          }
          this.setInfoACT(this.infoDataAct, false)
        } else {
          this.clearMap()
          this.$router.push({ path: '/seguimiento/search' })
          this.$vs.notify({
            text: this.$t("mapview.no_search"),
            color: "#64cc52",
            iconPack: "feather",
            icon: "icon-check-circle"
          })
        }
      } catch (error) {
        console.log(' ERROR EN BACKEND REQUEST:', error);
        console.log(' Error completo:', error.response || error);
        // Error genérico sin detalles técnicos
        this.clearMap()
        this.$router.push({ path: '/seguimiento/search' })
        this.$vs.notify({
          text: this.$t("mapview.no_search"),
          color: "#ff4757",
          iconPack: "feather",
          icon: "icon-x-circle"
        })
      }
    },
    async getCoordenadaVehicle(plate, company, version) {
      let url = `${window.location.origin}/tracking-api/v1/services/search/plate/`
      let data = {
        placa: plate,
        version: version,
        company: company
      }
      return new Promise((resolve) => {
        HTTP.setHeader(false)
        HTTP.post(url, data)
          .then((response) => {
            resolve(response.data)
          })
      })
    },
    clearMap() {
      this.setTracingMarkersArrayCliente([])
      this.setTracingMarkersArrayCedi([])
      this.setTracingMarkersArrayConductor([])
      this.setTracingMarkersArrayVehicle([])
      this.$store.dispatch("map/tracingPoint", [])
      this.DeactiveSocket()
    },
    async loginRoute() {
      let url = `${window.location.origin}/router-api/api/login/`
      // let url = 'https://srouter-dev.smartquick.com.co/api/login/'
      let jsonUser = {
        username: "admin",
        password: "Mnzx9874"
      }
      HTTP.setHeader(false)
      HTTP.post(url, jsonUser)
        .then((response) => {
          localStorage.setItem('TokenRoute', response.data.token)
        })
      // HTTP.post('https://integracion.smartquick.com.co:3005/v1/services/router/').then(function (response) {
      //   localStorage.setItem('TokenRoute', response.data.data)
      // })
    },
    calculateTime(cx_cliente, cy_cliente, cx_plate, cy_plate, country, plate) {
      let url = `${window.location.origin}/router-api/api/router/`
      // let url = 'https://srouter-dev.smartquick.com.co/api/router/'
      let data = {
        "strategy": "standard",
        "data": {
          "locations": [
            {
              "id": "7804710",
              "demands": {
                "weight": 0
              },
              "coords": [
                cx_cliente,
                cy_cliente
              ],
              "timewindows": {
                "1": [
                  "08:00",
                  "17:00"
                ]
              },
              "service_time": 3,
              "cluster_by": {
                "depot_id": "27d53467-2b89-43a0-afcf-b0230ab281e7"
              }
            }

          ],
          "depots": [
            {
              "id": "27d53467-2b89-43a0-afcf-b0230ab281e7",
              "capacity": 0,
              "coords": [
                cx_plate,
                cy_plate
              ],
              "timewindows": {
                "1": [
                  "8:00",
                  "18:00"
                ]
              },
              "zone": "0"
            }
          ],
          "vehicles": [
            {
              "id": plate,
              "capacities": {
                "weight": 3500000
              },
              "location_start": 0,
              "location_end": 0,
              "load_time": 0,

              "unload_time": 0,
              "timewindows": {
                "1": [
                  "05:00",
                  "22:00"
                ]
              },
              "priority": 99
            }
          ],
          "parameters": {
            "zone_admin_level": null,
            "merge_zones": false,
            "operation_start_time": "06:00",
            "operation_end_time": "19:00",
            "loc_time_window_disabled": false,
            "depot_start": true,
            "depot_return": false,
            "main_demand_attr_key": "weight",
            "location_merge": false,
            "loc_merge_radius": 0,
            "multi_routes": true,
            "n_routes": 1,
            "country": country,
            "osrm_url": null,
            "ordered": null,
            "osrm_profile": "car",
            "minimum_time_percent": 0.0,
            "minimum_capacity_percent": 0.0,
            "report_version": "v1.2"
          }
        }
      }
      return new Promise((resolve) => {
        HTTP.setHeader(false)
        HTTP.setRouter()

        HTTP.post(url, data)
          .then((response) => {
            resolve(response.data)
          })
      })
    },
    async setInfoACT(data, isSocket) {
      this.setWindowsClose(true)
      this.clearMap()
      this.dataInfo = data.data
      this.$store.dispatch('setDataInfo', this.dataInfo)
      this.dataInfo.company = data.companies
      let country = null
      this.show_driver = this.infoDataAct.status_show_driver.map((x) => x.status.toUpperCase()).includes(this.infoDataAct.data.estado.toUpperCase())
      if (isSocket) {
        country = this.dataInfo.company[0].country.toLowerCase()
        let status_show_delivery_time = this.company_status.filter((x) => x.status.toLowerCase() == this.dataInfo.estado.toLowerCase())
        if (status_show_delivery_time.length > 0) {
          this.show_delivery_time = true
        } else {
          this.show_delivery_time = false
        }
      } else {
        country = this.dataInfo.company.country.toLowerCase()
        this.company_status = this.dataInfo.company.company_status
        this.show_icon = this.dataInfo.company.show_icon
        this.show_trajectory_line = this.dataInfo.company.show_trajectory_line
        this.show_trajectory_line_resource = this.dataInfo.company.show_trajectory_line_resource
        if (this.dataInfo.company.show_delivery_time) {
          this.show_delivery_time = true
        } else {
          let status_show_delivery_time = this.dataInfo.company.company_status.filter((x) => x.status.toLowerCase() == this.dataInfo.estado.toLowerCase())
          if (status_show_delivery_time.length > 0) {
            this.show_delivery_time = true
          } else {
            this.show_delivery_time = false
          }
        }
      }
      let arrayMapCliente = []
      let arrayMapCedi = []
      if (this.dataInfo.placa != 'NINGUNO' && this.dataInfo.estado != 'Finalizado') {
        let  resultTime = {}
        const result = await this.getCoordenadaVehicle(this.dataInfo.placa, data.data.company, this.dataInfo.version)
        if (result != null) {
          this.getFirstPoint(result)
          if(this.show_trajectory_line_resource){
            resultTime = await this.calculateTime(this.dataInfo.cx_cliente, this.dataInfo.cy_cliente, result.lng, result.lat, country, this.dataInfo.placa)

            console.log(this.dataInfo.cx_cliente+","+this.dataInfo.cy_cliente+","+result.lng+","+result.lat+","+country)
            this.minuteRouter = resultTime.data.total_travel_time
          }
        }

        if(this.show_trajectory_line){
          console.log("paso 123")
          resultTime = await this.calculateTime(this.dataInfo.cx_cliente, this.dataInfo.cy_cliente, this.dataInfo.cx_cedi, this.dataInfo.cy_cedi, country)
          console.log("resultTime >>> ", resultTime)
          console.log(this.dataInfo.cx_cliente, this.dataInfo.cy_cliente, this.dataInfo.cx_cedi, this.dataInfo.cy_cedi, country)
        }

        const vehicleArray = resultTime.data.vehicles_route_report[0].line_string.geometry.coordinates
        this.polylineArray = []
        if (this.show_trajectory_line || this.show_trajectory_line_resource) {
          for (let i = 0; i < vehicleArray.length; i++) {
            this.polylineArray.push(
              L.latLng(vehicleArray[i][1], vehicleArray[i][0])
            )
          }
          this.setTracingMarkersArrayVehicle(this.polylineArray)
        }
        if (this.show_driver) {
          this.placa_tracing = this.dataInfo.placa
        }
        this.activateSocket()
        this.activateSocketPlaca(this.dataInfo.placa)
      }
      if (this.dataInfo.cx_cliente != null) {
        arrayMapCliente.push({
          id: 1,
          position: {
            lng: this.dataInfo.cx_cliente,
            lat: this.dataInfo.cy_cliente
          },
          tooltip: this.dataInfo,
          draggable: false,
          visible: true
        })
      }
      if (this.show_icon) {
        if (this.dataInfo.cx_cedi != null) {
          arrayMapCedi.push({
            id: 2,
            position: {
              lng: this.dataInfo.cx_cedi,
              lat: this.dataInfo.cy_cedi
            },
            tooltip: this.dataInfo,
            draggable: false,
            visible: true
          })
          this.setTracingMarkersArrayCedi(arrayMapCedi)
        }
      }
      this.setTracingMarkersArrayCliente(arrayMapCliente)
      this.$store.dispatch("map/visibleTracingPoint", true)
      if (this.dataInfo.cx_cliente != null) {
        this.$store.dispatch("map/centerSet", [this.dataInfo.cy_cliente, this.dataInfo.cx_cliente])
      } else if (this.dataInfo.cx_cedi != null) {
        this.$store.dispatch("map/centerSet", [this.dataInfo.cy_cedi, this.dataInfo.cx_cedi])
      } else {
        console.log('No Existe')
      }
      this.activeSocketService(this.dataInfo.guia)
      setTimeout(() => {
        this.$store.dispatch("map/zoomSet", 11)
      }, 500)
    },
    close(val) {//eslint-disable-line
      this.popupActivo2 = false
    },
    async setChangeTracingPoint(data) {
      var tracingArray = this.$store.state.map.tracingMarkersArray
      tracingArray.forEach((element, index) => {
        if (element.tooltip.id_cedula == data.document) {
          tracingArray[index].position.lat = data.latitude
          tracingArray[index].position.lng = data.longitude
          tracingArray[index].visible = false
        }
      })
      this.setTracingMarkersArray(tracingArray)
      tracingArray.forEach((element, index) => {
        tracingArray[index].visible = true
      })
      this.setTracingMarkersArray(tracingArray)
    },
    setCenter(x) {
      this.$store.dispatch("map/centerSet", [x.latitude, x.longitude])
      this.$store.dispatch("map/zoomSet", 3.5)
    },
    buildTracingPoint(val) {
      var markerss = []
      for (let i = 0; i < val.length; i++) {
        val[i]["visible"] = true
        markerss.push({
          id: val[i].id,
          position: {
            lng: val[i].point.coordinates[0],
            lat: val[i].point.coordinates[1]
          },
          tooltip: val[i],
          draggable: false,
          visible: true
        })
      }
      this.markers = markerss
      this.setTracingMarkersArray(markerss)
    },
    setTracingMarkersArrayCliente(data) {
      this.$store.dispatch("map/tracingMarkersCliente", data)
    },
    setTracingMarkersArrayCedi(data) {
      this.$store.dispatch("map/tracingMarkersCedi", data)
    },
    setTracingMarkersArrayConductor(data) {
      this.$store.dispatch("map/tracingMarkersConductor", data)
    },
    setTracingMarkersArrayVehicle(data) {
      this.$store.dispatch("map/setPolylineArray", data)
    },
    setWindows(val) {
      for (var variable in this.objectSidebar) {
        if (variable == val.name) {
          this.objectSidebar[val.name] = !this.objectSidebar[val.name]
        } else {
          this.objectSidebar[variable] = false
        }
      }
      let keys = Object.keys(this.objectSidebar)
      let find = false
      for (let i = 0; i < Object.keys(this.objectSidebar).length; i++) {
        if (this.objectSidebar[keys[i]] == true) {
          find = true
        }
      }
      this.$store.dispatch("map/visibleTracingPoint", !find)
      this.$store.dispatch("map/visibleTracing", false)
    }

  },
  events: {
    "show-set"(value) {
      this.objectSidebar.showSideBarTableService = value
      // let val = this.$store.state.map.visibleTracingPoint
      // this.$store.dispatch('map/visibleTracingPoint', !val)
      let keys = Object.keys(this.objectSidebar)
      let find = false
      for (let i = 0; i < Object.keys(this.objectSidebar).length; i++) {
        if (this.objectSidebar[keys[i]] == true) {
          find = true
        }
      }
      this.$store.dispatch("map/visibleTracingPoint", !find)
      this.$store.dispatch("map/visibleTracing", false)
    },
    "show-setWindows"(val) {
      for (var variable in this.objectSidebar) {
        if (variable == val.name) {
          this.objectSidebar[val.name] = !this.objectSidebar[val.name]
        } else {
          this.objectSidebar[variable] = false
        }
      }
      let keys = Object.keys(this.objectSidebar)
      let find = false
      for (let i = 0; i < Object.keys(this.objectSidebar).length; i++) {
        if (this.objectSidebar[keys[i]] == true) {
          find = true
        }
      }
      this.$store.dispatch("map/visibleTracingPoint", !find)
      this.$store.dispatch("map/visibleTracing", false)
    }
  }
}
</script>
<style scoped>
.v--modal-overlay {
  background: rgba(0, 0, 0, 0);
  z-index: 999999;
}

.closed-button {
  font-size: 26px;
  border: 1px solid;
  width: 37px;
  text-align: center;
  color: white;
  background-color: black;
  position: relative;
}

.w-30 {
  width: 2.5em;
  height: 2.5em;
  max-width: 3em;
  margin-right: 2em;
  margin-left: 2em;
}

.w-40 {
  max-width: 2.8em;
}

a:hover {
  color: white;
}
</style>